export default __webpack_public_path__ + "static/media/IND.d5eca72b.png";